module.exports = __webpack_public_path__ + "static/media/toolbox.8648f081.svg";